<script lang="ts">
    import { useNavigate } from 'svelte-navigator';
    import { IS_AUTHENTICATED, IS_ORGANIZATION_APPROVED } from '@smatch/cassiopeia-web-components';

    const navigate = useNavigate();

    const onAuthenticationChange = (isAuthenticated: boolean, isApproved: boolean): void => {

        if (isAuthenticated && !isApproved) {
            return;
        }

        if (window.location.pathname.includes('/landing')) {
            return;
        }

        if (isAuthenticated && isApproved) {
            const REDIRECT_URL = new URLSearchParams(window.location.search).get('url');

            navigate(REDIRECT_URL === null ? '/auctions' : decodeURIComponent(REDIRECT_URL));
            return;
        }

        // eslint-disable-next-line @typescript-eslint/naming-convention
        navigate('/authentication', { replace: true });
    };

    $: onAuthenticationChange($IS_AUTHENTICATED, $IS_ORGANIZATION_APPROVED);

</script>

{#if $IS_AUTHENTICATED && !$IS_ORGANIZATION_APPROVED}
    <slot />
{/if}